"use client";

import { Employer, GovernmentEmployer } from "@entities/employer";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useStorageFile } from "@shared/storage";
import { DetailItem } from "@shared/ui";
import { formatDate } from "@shared/utils";
import { StorageBucket } from "@sisnaker-react-core/karirhub-model-type";
import Image from "next/image";

export function GovernmentEmployerBasicDetails({ employer }: { employer: Employer }) {
  const government = employer.employerable as GovernmentEmployer;

  const { getInitialFile } = useStorageFile();
  const logoFile = getInitialFile({ bucket: StorageBucket["karirhub-employer-logos"], fileId: employer?.logoFileId });

  if (!employer || !government) return <></>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      <div>
        <DetailItem label="Lembaga/Instansi" value={employer.name || "-"} />
      </div>
      <div>
        <DetailItem label="Tanggal berdiri" value={government.establishmentDate ? formatDate(government.establishmentDate) : "-"} />
      </div>
      <div className="md:col-span-2">
        <DetailItem label="Deskripsi singkat entitas" value={employer.description || "-"} />
      </div>
      <div>
        <DetailItem label="Nomor telepon entitas" value={employer.phone || "-"} />
      </div>
      <div>
        <DetailItem label="Email resmi entitas" value={employer.email || "-"} />
      </div>
      <div>
        <DetailItem label="Situs web" value={employer.website || "-"} />
      </div>
      <div>
        <DetailItem
          label="Logo entitas"
          value={
            employer.logoFileId && logoFile && logoFile[0] ? (
              <a className="flex items-center gap-4" href={logoFile[0].download_link} target="_blank">
                <span className="flex-1 flex items-center gap-2">
                  <Image src={logoFile[0].download_link} width={40} height={40} className="size-10 min-w-10 h-10" alt={logoFile[0].name} />
                  <span>{logoFile[0].name}</span>
                </span>
                <ArrowDownTrayIcon className="size-4 min-w-4" />
              </a>
            ) : (
              "-"
            )
          }
        />
      </div>
    </div>
  );
}
